<template>
    <div>
        <b-modal
            id="domainResponsibleFormModal"
            centered
            size="xl"
            no-close-on-backdrop
            ref="domainResponsibleFormModal"
            :title=" $t('domainResponsible.info')"
            :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')"
            cancel-variant="outline-secondary"
            @ok.prevent="addOrUpdate"
            hide-footer
        >
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon icon="LockIcon" size="18" />
                <span class="align-middle ml-50">{{  $t('domainResponsible.responsible')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <table class="table table-striped table-bordered">
              <tbody>
                <tr v-for="domainResponsibleItem in domainResponsibleList" :key="domainResponsibleItem.id">
                  <td >
                      <b-form-checkbox @change="changeResponsible($event, domainResponsibleItem.id, domainResponsibleItem.mailContactTypeId)" />                                 
                  </td>
                  <td>{{  domainResponsibleItem.name  }}</td>
                  <td>{{  domainResponsibleItem.email  }}</td>
                  <td>
                    <b-form-select v-model="domainResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                  </td>
                  <td>{{  domainResponsibleItem.responsibleField  }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getDomainResponsibleList: {type: Function},
    },
  data(){
    return {
        domainId: 0, 
        domainResponsibleList:[],
        mailContactTypeList:[],
    }
  },
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'DomainResponsible' }
      if (selected == true) {
        const data = { domainId: this.domainId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getDomainResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(domainId, clientId) {
      this.$refs['domainResponsibleFormModal'].show()
          this.domainId= domainId
          const data = {clientId: clientId,domainId: domainId}
          const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
              if(response.data.resultStatus == true){    
                  this.domainResponsibleList = response.data.clientResponsibleList
                  this.mailContactTypeList = response.data.mailContactTypeList
              } else {
                  this.$bvModal.hide('domainResponsibleFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }  
          }) 
      },
  }
}
</script>